export class RmAssessment {
    private id!: number;
    private agentChannel!: string;
    private remarkContent!: string;
    private updatedbyrole!: string;
    private Tier!: string;
    private remarkid!: number;
    private rm_not_applicable!: boolean;
    private rm_declaration_date!: string;
    private rep_designation!:string;
    private representativebanding!:string;

    constructor() { }

    // Getters & Setters
    getId(): number {
        return this.id;
    }
    setId(id: number) {
        this.id = id;
    }

    getRemarkId(): number {
        return this.remarkid;
    }
    setRemarkId(remarkid: number) {
        this.remarkid = remarkid;
    }

    getAgentChannel(): string {
        return this.agentChannel;
    }

    setAgentChannel(agentChannel: string) {
        this.agentChannel = agentChannel;
    }

    getRemarkContent(): string {
        return this.remarkContent;
    }

    setRemarkContent(remarkContent: string) {
        this.remarkContent = remarkContent;
    }

    getupdatedbyrole(): string {
        return this.updatedbyrole;
    }

    setupdatedbyrole(updatedbyrole: string) {
        this.updatedbyrole = updatedbyrole;
    }

    getRm_not_applicable(): boolean {
        return this.rm_not_applicable;
    }

    setRm_not_applicable(rm_not_applicable: boolean) {
        this.rm_not_applicable = rm_not_applicable;
    }

    getRm_declaration_date(): string {
        return this.rm_declaration_date;
    }

    setRm_declaration_date(rm_declaration_date: string) {
        this.rm_declaration_date = rm_declaration_date;
    }

    getTier(): string {
        return this.Tier;
    }

    setTier(Tier: string) {
        this.Tier = Tier;
    }

    getRepDesignation(): string {
        return this.rep_designation;
    }

    setRepDesignation(rep_designation: string) {
        this.rep_designation = rep_designation;
    }

    getRepresentativebanding(): string {
        return this.representativebanding;
    }

    setRepresentativebanding(representativebanding: string) {
        this.representativebanding = representativebanding;
    }


    toString() {
        return JSON.stringify({
            id: this.getId(),
            remarkid: this.getRemarkId(),
            agentChannel: this.getAgentChannel(),
            rep_designation:this.getRepDesignation(),
            representative_banding:this.getRepresentativebanding(),
            remarkContent: this.getRemarkContent(),
            updated_by_role: this.getupdatedbyrole(),
            Tier: this.getTier(),
            rm_not_applicable: this.getRm_not_applicable(),
            rm_declaration_date: this.getRm_declaration_date()
        });
    }
}
